import { InputBase } from '@material-ui/core'
import { Fragment, useContext } from 'react'
import { VideoContentContext, VideoContentContextType } from '../context/VideoContext'
// import { Input } from './component/Input/index'
import SettingEditor from './editor2'
import { widgetRules, rulesIf } from './rules'

export default function StoryTelling() {
  const {
    handleChange,
    content: [content],
  } = useContext(VideoContentContext) as VideoContentContextType
  // useEffect(() => {
  //   return () => {}
  // }, [])
  return (
    <Fragment>
      {content &&
        content.widgets.map((item: any, index: number) => {
          const rules: rulesIf = widgetRules[item.template || 'basic']
          return (
            <Fragment key={`widget_${index}`}>
              {rules.title && (
                <InputBase
                  // label="Title"
                  placeholder="input title ..."
                  value={item.title}
                  onChange={(ev) => {
                    handleChange(`widgets[${index}].title`, ev.target.value)
                  }}
                />
              )}
              {rules.abstract && (
                <InputBase
                  // label="Abstract"
                  placeholder="input abstract ..."
                  value={item.abstract}
                  onChange={(ev) => {
                    handleChange(`widgets[${index}].abstract`, ev.target.value)
                  }}
                />
              )}
              {content.id && (
                <>
                  <SettingEditor index={index} />
                </>
              )}
            </Fragment>
          )
        })}
    </Fragment>
  )
}
